export default __webpack_public_path__ + "static/media/cancel-icon.867db475.svg";